import React from "react";

/**
 * Reusable faint orbital ornament for section backgrounds.
 * Adds visual continuity across the whole site.
 */
export const SectionOrnament = ({
  side = "right",
  size = 460,
  vertical = "top-1/3",
  color = "#5C5549",
  opacity = 0.1,
  className = "",
}) => {
  const horiz =
    side === "right"
      ? "-right-32"
      : side === "left"
      ? "-left-32"
      : "left-1/2 -translate-x-1/2";
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, opacity }}
      className={`absolute ${horiz} ${vertical} pointer-events-none ${className}`}
      aria-hidden="true"
    >
      <circle cx="200" cy="200" r="190" stroke={color} strokeWidth="0.5" strokeDasharray="2 6" />
      <ellipse
        cx="200"
        cy="200"
        rx="160"
        ry="130"
        stroke={color}
        strokeWidth="0.5"
        transform="rotate(-15 200 200)"
      />
      <circle cx="200" cy="200" r="100" stroke={color} strokeWidth="0.5" strokeDasharray="1 3" />
      <ellipse
        cx="200"
        cy="200"
        rx="70"
        ry="55"
        stroke={color}
        strokeWidth="0.5"
        transform="rotate(20 200 200)"
      />
      <circle cx="20" cy="200" r="3" fill="#8C6A48" />
      <circle cx="380" cy="200" r="2" fill={color} />
      <circle cx="200" cy="20" r="2" fill={color} />
      <circle cx="280" cy="320" r="2.5" fill="#8C6A48" />
    </svg>
  );
};

export default SectionOrnament;
